import { useContext } from 'react';
import { ActionsContext, ActionsContextValue } from './ActionsContext';

export const useActionsContext = (): ActionsContextValue => useContext(ActionsContext);
